import React from "react";

import { connect } from "../i18n/connect";
import {
  fetchMoreNotifications,
  fetchNotifications,
  markAsRead,
  setSelectedTab,
  setFilter,
  setAllFilters,
  setFilters,
  resetFilters
} from "../redux/modules/newNotifications";
import {
  getFilters,
  getGlobalLoading,
  getInitialFetchComplete,
  getLoading,
  getNotificationsTabs,
  getNotificationTypesFilters,
  getSelectedNotificationsTab,
  getUnreadCount
} from "../redux/modules/newNotifications/selector";
import { actions } from "../redux/modules/notifications";

export default function withNewNotifications(WrappedComponent) {
  const mapStateToProps = state => ({
    notificationsTabs: getNotificationsTabs(state),
    notificationTypesFilters: getNotificationTypesFilters(state),
    selectedNotificationsTab: getSelectedNotificationsTab(state),
    filters: getFilters(state),
    loading: getLoading(state),
    globalLoading: getGlobalLoading(state),
    unreadCount: getUnreadCount(state),
    initialFetchComplete: getInitialFetchComplete(state)
  });

  const mapDispatchToProps = {
    setFilter: setFilter,
    setAllFilters: setAllFilters,
    setFilters: setFilters,
    resetFilters: resetFilters,
    setSelectedNotificationsTab: setSelectedTab,
    fetchNotificationsAction: actions.fetchNotifications,
    fetchNotifications: fetchNotifications,
    fetchMoreNotifications: fetchMoreNotifications,
    markAsReadAction: markAsRead
  };

  @connect(mapStateToProps, mapDispatchToProps)
  class WithNotifications extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithNotifications;
}
